module.exports = __webpack_public_path__ + "img/recover-credentials-example.551b0837.png";